import React from 'react';
import { 
  FormControl, 
  FormLabel, 
  Box 
} from '@mui/material';

function FormGroup({ label, children, required = false }) {
  return (
    <FormControl fullWidth className="mb-5">
      {label && (
        <FormLabel required={required} className="mb-2 font-semibold">
          {label}
        </FormLabel>
      )}
      <Box>
        {children}
      </Box>
    </FormControl>
  );
}

export default FormGroup;
